// extracted by mini-css-extract-plugin
export default {"btop":"a5db50f024 _11d566038b _15f8b61f19","icon":"ebe3e6e0bf _4b0ad03bf6","btoppink":"dbf2a2d28f fce1bace0e"};